// removed by extract-text-webpack-plugin
module.exports = {"container":"_1Qtte","spacing":"_3eEOu","buttonContainer":"_1fm1I","icon":"_8Cbaj","controls":"_1B6lJ","table":"_23YP-","paginationContainer":"_1bf1S","separatorColumn":"_3NJhh"};


//////////////////
// WEBPACK FOOTER
// ./app/components/post-list/post-list-classic.scss
// module id = 1538
// module chunks = 0